import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store.js'
import './assets/styles/global.css'


Vue.config.productionTip = false
Vue.prototype.$filterStore = [];



const app = new Vue({
  vuetify,
  store,
  render: h => h(App)
})
app.$mount('#app')


